import {FC, ReactNode, useMemo} from 'react';
import {RFConfigContext, TRFConfigContext} from '@progress-fe/rf-core';
import {observer} from 'mobx-react-lite';
import {useStore} from 'core';

const ProjectRFConfigContextFC: FC<{children: ReactNode}> = ({children}) => {
  const {techProcessStore} = useStore();

  const value: TRFConfigContext = useMemo(
    () => ({
      isInspector: techProcessStore?.developerMode.isInspector
    }),
    [techProcessStore?.developerMode.isInspector]
  );

  return <RFConfigContext.Provider value={value}>{children}</RFConfigContext.Provider>;
};

export const ProjectRFConfigContext = observer(ProjectRFConfigContextFC);
